module.exports = __webpack_public_path__ + "static/media/warning.3d76b6de.svg";